import {z} from 'zod';

export const externalUserIdParams = z.object({
  externalUserId: z.string().min(1, 'External User ID is required'),
});

export type ExternalUserIdParams = z.infer<typeof externalUserIdParams>;
